import { Injectable } from '@angular/core';
import { ProgramVm, ResourceVm } from 'qp-ui-interface';

@Injectable({
  providedIn: 'root',
})
export class ParentalControlDialogService {
  constructor() {}

  async checkExplicitContent(_: ResourceVm): Promise<boolean> {
    return Promise.resolve(true);
  }

  async checkExplicitProgramContent(_: ProgramVm): Promise<boolean> {
    return Promise.resolve(true);
  }
}
